import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="observability--bulk-select"
// Manages checkbox selection for bulk retry of failed jobs
export default class extends Controller {
  static targets = [
    "selectAll",
    "checkbox",
    "actionBar",
    "count",
    "submitButton",
  ]
  static values = {
    selectedLabel: { type: String, default: "{count} selected" },
  }

  toggle() {
    this.updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
    this.updateState()
  }

  updateState() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked)
    const total = this.checkboxTargets.length

    // Update select all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked.length === total && total > 0
      this.selectAllTarget.indeterminate =
        checked.length > 0 && checked.length < total
    }

    // Show/hide action bar
    if (this.hasActionBarTarget) {
      if (checked.length > 0) {
        this.actionBarTarget.classList.remove("hidden")
        if (this.hasCountTarget) {
          this.countTarget.textContent = this.selectedLabelValue.replace(
            "{count}",
            checked.length,
          )
        }
      } else {
        this.actionBarTarget.classList.add("hidden")
      }
    }

    // Enable/disable submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = checked.length === 0
    }
  }
}
